import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';
import { DataTableShell } from './DataTable';
import './LibraryCollection.css';

/** Match Library presentation only. Callers retain queries, rows and pagination. */
export function LibraryCollection({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <section className={cn('library-collection', className)} {...props} />;
}
export function LibraryCollectionToolbar({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('library-collection-toolbar', className)} {...props} />;
}
export function LibraryCollectionTableShell({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <DataTableShell className={cn('library-collection-table-shell rounded-[18px]', className)} {...props} />;
}
export function LibraryCollectionFooter({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return <footer className={cn('library-collection-footer', className)} {...props} />;
}
